const assetsLang = {
  en: {
    // General asset management
    assets: "Assets",
    assetsList: "Assets list",
    addAsset: "Add asset",
    editAsset: "Edit asset",
    assetDetails: "Asset details",

    // Asset properties
    assetName: "Asset name",
    assetCode: "Asset code",
    assetType: "Asset type",
    productType: "Product type",
    acquisitionDate: "Acquisition date",
    expiryDate: "Expiry date",
    value: "Value",
    valueProduct: "Product value",
    depreciation: "Depreciation",
    percentDepreciation: "Depreciation percentage",
    observations: "Observations",

    // Asset related entities
    productTypes: "Product types",
    unitMeasurement: "Unit of measurement",
    cooperant: "Cooperant",
    provider: "Provider",

    // Asset statuses
    inactive: "Inactive",
    actives: "Actives",
    activeList: "Active list",
    addActive: "Add active",

    generateQRCode: "Generate QR Code",
    assetVerificationQR: "Asset verification QR Code",
    assetID: "Asset ID",
    scanQRToVerify: "Scan this QR code to verify the asset",
    downloadQR: "Download QR",

    // Asset assignment
    assignAsset: "Assign asset",
    assignments: "Assignments",
    newAssignment: "New assignment",
    deliveryDate: "Delivery date",
    returnDate: "Return date",
    returnAsset: "Return asset",
    currentAssignee: "Current assignee",
    assignmentHistory: "Assignment history",
    noAssignmentsFound: "No assignments found",
    headquarters: "Headquarters",
    user: "User",

    // Asset operations
    printCard: "Print card",
    printResponsibilityCard: "Print responsibility card",
    responsibilityCard: "Responsibility card",
    deleteAsset: "Delete asset",
    transferAsset: "Transfer asset",
    disposeAsset: "Dispose asset",
    assignmentCreatedSuccessfully: "Assignment created successfully",

    // Success messages
    asset_insert_successful: "The asset has been saved successfully",
    asset_updated_successful: "The asset has been updated successfully",
    asset_deleted_successful: "The asset has been deleted successfully",
    asset_assignment_successful: "The asset has been assigned successfully",
    asset_return_successful: "The asset has been returned successfully",
    active_list_retrieved: "Asset list retrieved successfully",
    active_insert_error: "The asset could not be saved",
    active_insert_successful: "The asset has been saved successfully",
    active_not_found: "Asset not found",
    active_retrieved_successful: "Asset retrieved successfully",
    active_update_error: "The asset could not be updated",
    active_updated_successful: "The asset has been updated successfully",
    active_deleted_successful: "The asset has been deleted successfully",

    // Confirmation messages
    sureDeleteAsset: "Are you sure you want to delete this asset?",
    sureReturnAsset: "Are you sure you want to return this asset?",

    // Search and filter
    searchAsset: "Search asset",
    filterByType: "Filter by type",
    filterByStatus: "Filter by status",
    filterByLocation: "Filter by location",
    filterByDates: "Filter by dates",

    selectDate: "Select date",
    expenseRequest: "Expense request",
    image: "Image",
    noImageSelected: "No image selected",
    editActive: "Edit active",
    depreciationPercentage: "Depreciation percentage",
    returnReasons: "Returns reasons",
    confirm: "Confirm",
    administrativeActives: "Institutional actives",

    // Reports
    assetReports: "Asset reports",
    depreciationReport: "Depreciation report",
    assignmentReport: "Assignment report",
    inventoryReport: "Inventory report",
    exportToExcel: "Export to excel",
    exportToPDF: "Export to pdf",

    // Attachments
    noAttachments: "No attachments",
    fileName: "File name",
    fileType: "File type",
    fileSize: "File size",
    uploadDate: "Upload date",
    confirmDeleteAttachment: "Are you sure you want to delete this attachment?",
    attachmentSavedSuccessfully: "Attachment saved successfully",
    attachmentDeletedSuccessfully: "Attachment deleted successfully",
    errorLoadingAttachments: "Error loading attachments",
    errorSavingAttachment: "Error saving attachment",
    errorDeletingAttachment: "Error deleting attachment",
    invalidFileType: "Invalid file type. Allowed: PDF, JPG, PNG, DOC, DOCX, XLS, XLSX",
    fileSizeExceeded: "File size exceeded. Maximum allowed: {0}",
    uploadError: "Error uploading file",
    generalInfo: "General information",
    
    // Brand and Model
    brand: "Brand",
    model: "Model",
    serialNumber: "Serial number",
    selectBrand: "Select brand",
    selectModel: "Select model",

    // Bank Account
    bankAccount: "Bank account",
    bank: "Bank",
    accountNumber: "Account number",
    selectBank: "Select bank",
    
    // Maintenance
    maintenanceLog: "Maintenance log",
    maintenanceHistory: "Maintenance history",
    newMaintenance: "New maintenance",
    editMaintenance: "Edit maintenance",
    maintenanceDate: "Maintenance date",
    maintenanceType: "Maintenance type",
    preventive: "Preventive",
    corrective: "Corrective",
    predictive: "Predictive",
    performedBy: "Performed by",
    cost: "Cost",
    nextMaintenance: "Next maintenance",
    nextMaintenanceDate: "Next maintenance date",
    scheduled: "Scheduled",
    in_progress: "In progress",
    completed: "Completed",
    cancelled: "Cancelled",
    noMaintenanceRecords: "No maintenance records found",
    confirmDeleteMaintenance: "Are you sure you want to delete this maintenance record?",
    maintenanceCreated: "Maintenance record created successfully",
    maintenanceUpdated: "Maintenance record updated successfully",
    maintenanceDeleted: "Maintenance record deleted successfully",
    errorLoadingMaintenances: "Error loading maintenance records",
    errorSavingMaintenance: "Error saving maintenance record",
    errorDeletingMaintenance: "Error deleting maintenance record",
    selectType: "Select type",
    selectStatus: "Select status",
    selectUser: "Select user",
    enterName: "Enter name",
    enterDescription: "Enter description",
    additionalObservations: "Additional observations",
    errorLoadingData: "Error loading data"
  },
  es: {
    // General asset management
    assets: "Activos",
    assetsList: "Listado de activos",
    addAsset: "Agregar activo",
    editAsset: "Editar activo",
    assetDetails: "Detalles del activo",

    // Asset properties
    assetName: "Nombre del activo",
    assetCode: "Código del activo",
    assetType: "Tipo de activo",
    productType: "Tipo de producto",
    acquisitionDate: "Fecha de adquisición",
    expiryDate: "Fecha de vencimiento",
    value: "Valor",
    valueProduct: "Valor del producto",
    depreciation: "Depreciación",
    percentDepreciation: "Porcentaje de depreciación",
    observations: "Observaciones",

    // Asset related entities
    productTypes: "Tipos de productos",
    unitMeasurement: "Unidad de medida",
    cooperant: "Cooperante",
    provider: "Proveedor",

    // Asset statuses
    inactive: "Inactivo",
    actives: "Activos",
    activeList: "Lista de activos",
    addActive: "Agregar activo",

    generateQRCode: "Generar código QR",
    assetVerificationQR: "Código QR de verificación",
    assetID: "ID del Activo",
    scanQRToVerify: "Escanea este código QR para verificar el activo",
    downloadQR: "Descargar QR",

    // Asset assignment
    assignAsset: "Asignar activo",
    assignments: "Asignaciones",
    newAssignment: "Nueva asignación",
    deliveryDate: "Fecha de entrega",
    returnDate: "Fecha de devolución",
    returnAsset: "Devolver activo",
    currentAssignee: "Asignado actualmente a",
    assignmentHistory: "Historial de asignaciones",
    noAssignmentsFound: "No se encontraron asignaciones",
    headquarters: "Sede",
    user: "Usuario",

    // Asset operations
    printCard: "Imprimir tarjeta",
    printResponsibilityCard: "Imprimir tarjeta de responsabilidad",
    responsibilityCard: "Tarjeta de responsabilidad",
    deleteAsset: "Eliminar activo",
    transferAsset: "Transferir activo",
    disposeAsset: "Dar de baja",
    assignmentCreatedSuccessfully: "Activo creado exitosamente",

    // Success messages
    asset_insert_successful: "El activo se ha guardado correctamente",
    asset_updated_successful: "El activo se ha actualizado correctamente",
    asset_deleted_successful: "El activo se ha eliminado correctamente",
    asset_assignment_successful: "El activo se ha asignado correctamente",
    asset_return_successful: "El activo ha sido devuelto correctamente",
    active_list_retrieved: "Listado de activos obtenido correctamente",
    active_insert_error: "No se pudo guardar el activo",
    active_insert_successful: "El activo se ha guardado correctamente",
    active_not_found: "Activo no encontrado",
    active_retrieved_successful: "Activo obtenido correctamente",
    active_update_error: "No se pudo actualizar el activo",
    active_updated_successful: "El activo se ha actualizado correctamente",
    active_deleted_successful: "El activo se ha eliminado correctamente",

    // Confirmation messages
    sureDeleteAsset: "¿Está seguro que desea eliminar este activo?",
    sureReturnAsset: "¿Está seguro que desea devolver este activo?",

    // Search and filter
    searchAsset: "Buscar activo",
    filterByType: "Filtrar por tipo",
    filterByStatus: "Filtrar por estado",
    filterByLocation: "Filtrar por ubicación",
    filterByDates: "Filtrar por fechas",

    selectDate: "Seleccionar fecha",
    expenseRequest: "ID de solicitud",
    image: "Imagen",
    noImageSelected: "Ninguna imagen seleccionada",
    editActive: "Editar activo",
    depreciationPercentage: "Porcentaje de depreciación",
    returnReasons: "Razón de devolución",
    confirm: "Confirmar",
    administrativeActives: "Activos institucionales",

    // Reports
    assetReports: "Reportes de activos",
    depreciationReport: "Reporte de depreciación",
    assignmentReport: "Reporte de asignaciones",
    inventoryReport: "Reporte de inventario",
    exportToExcel: "Exportar a excel",
    exportToPDF: "Exportar a pdf",

    // Attachments
    noAttachments: "Sin adjuntos",
    fileName: "Nombre del archivo",
    fileType: "Tipo de archivo",
    fileSize: "Tamaño del archivo",
    uploadDate: "Fecha de carga",
    confirmDeleteAttachment: "¿Está seguro que desea eliminar este adjunto?",
    attachmentSavedSuccessfully: "Adjunto guardado exitosamente",
    attachmentDeletedSuccessfully: "Adjunto eliminado exitosamente",
    errorLoadingAttachments: "Error al cargar los adjuntos",
    errorSavingAttachment: "Error al guardar el adjunto",
    errorDeletingAttachment: "Error al eliminar el adjunto",
    invalidFileType: "Tipo de archivo inválido. Permitidos: PDF, JPG, PNG, DOC, DOCX, XLS, XLSX",
    fileSizeExceeded: "Tamaño de archivo excedido. Máximo permitido: {0}",
    uploadError: "Error al cargar el archivo",
    generalInfo: "Información general",
    
    // Brand and Model
    brand: "Marca",
    model: "Modelo",
    serialNumber: "Número de serie",
    selectBrand: "Seleccionar marca",
    selectModel: "Seleccionar modelo",

    // Bank Account
    bankAccount: "Cuenta bancaria",
    bank: "Banco",
    accountNumber: "Número de cuenta",
    selectBank: "Seleccionar banco",
    
    // Maintenance
    maintenanceLog: "Bitácora de mantenimientos",
    maintenanceHistory: "Historial de mantenimientos",
    newMaintenance: "Nuevo mantenimiento",
    editMaintenance: "Editar mantenimiento",
    maintenanceDate: "Fecha de mantenimiento",
    maintenanceType: "Tipo de mantenimiento",
    preventive: "Preventivo",
    corrective: "Correctivo",
    predictive: "Predictivo",
    performedBy: "Realizado por",
    cost: "Costo",
    nextMaintenance: "Próximo mantenimiento",
    nextMaintenanceDate: "Fecha del próximo mantenimiento",
    scheduled: "Programado",
    in_progress: "En progreso",
    completed: "Completado",
    cancelled: "Cancelado",
    noMaintenanceRecords: "No se encontraron registros de mantenimiento",
    confirmDeleteMaintenance: "¿Está seguro que desea eliminar este registro de mantenimiento?",
    maintenanceCreated: "Registro de mantenimiento creado exitosamente",
    maintenanceUpdated: "Registro de mantenimiento actualizado exitosamente",
    maintenanceDeleted: "Registro de mantenimiento eliminado exitosamente",
    errorLoadingMaintenances: "Error al cargar los registros de mantenimiento",
    errorSavingMaintenance: "Error al guardar el registro de mantenimiento",
    errorDeletingMaintenance: "Error al eliminar el registro de mantenimiento",
    selectType: "Seleccionar tipo",
    selectStatus: "Seleccionar estado",
    selectUser: "Seleccionar usuario",
    enterName: "Ingrese el nombre",
    enterDescription: "Ingrese la descripción",
    additionalObservations: "Observaciones adicionales",
    errorLoadingData: "Error al cargar datos"
  }
};

export default assetsLang;